import { type ReactNode } from 'react';

interface Props {
  children?: ReactNode;
  condition: boolean;
  whenTrue?: ReactNode;
  whenFalse?: ReactNode;
}

export function Render({ children = null, condition, whenTrue = null, whenFalse = null }: Props) {
  if (!condition) {
    return whenFalse ? <>{whenFalse}</> : null;
  }

  return <>{whenTrue ?? children}</>;
}
